import styled from "styled-components";
import {useSelector} from "react-redux";
import React from "react";
import ChampionSkillImage from "../../../common/ChampionSkillImage";

const Wrapper = styled.div`
  display: flex;
`;
const PaddingBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  & + & {
    margin-left: 5px;
  }
`;

const ListTagValue = styled.div`
  border-radius: 4px;
  background-color: ${props => {
    let color = props.theme.color.white_200;
    if (props.isFirstMastered) color = props.theme.color.green_200
    if (props.last) color = props.theme.color.green_200;
    return color;
  }};

  font-size: 14px;
  font-weight: ${props => {
    let weight = 500;
    if (props.isFirstMastered || props.last) weight = 'bold';
    return weight
  }};
  width: 24px;
  aspect-ratio: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${props => {
    let color = props.theme.color.dark_200;
    if (props.last || props.isFirstMastered) color = props => props.theme.color.green_100;

    return color;
  }};

`;

const ArrowBox = styled.div`
  margin: 0 5px;
`;

const SkillWrapper = styled.div`
  height: 32px;
  display: flex;
  flex-direction: row;
`;

const SequenceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const BuildSkillSq = ({list, champion_id, skillList,skillValue}) => {
    return (
        <Wrapper>
            {/*<SkillWrapper>*/}
            {/*    {skillValue.map((item, index) => {*/}
            {/*        return (*/}
            {/*            <ChampionSkillImage*/}
            {/*                width={32}*/}
            {/*                height={32}*/}
            {/*                key={index}*/}
            {/*                spell={skillList?.spells[getSkillId(item.text)]}*/}
            {/*                version={version}*/}
            {/*                img={skillList?.spells[getSkillId(item.text)]?.image?.full}*/}
            {/*                absoluteText={item.text}*/}
            {/*            >*/}
            {/*                {index + 1 !== skillValue.length && <ArrowBox>*/}
            {/*                    <img src={'/images/icon_collapse_arrow.svg'} width={14} height={14}/>*/}
            {/*                </ArrowBox>}*/}
            {/*            </ChampionSkillImage>*/}
            {/*        )*/}
            {/*    })}*/}
            {/*</SkillWrapper>*/}
            <SequenceWrapper>
                <SkillContentBox skillList={skillList} skillId={'Q'} list={list}/>
                <SkillContentBox skillList={skillList} skillId={'W'} list={list}/>
                <SkillContentBox skillList={skillList} skillId={'E'} list={list}/>
                <SkillContentBox skillList={skillList} skillId={'R'} list={list}/>
                {/*{list?.map((item, index) => {*/}
                {/*    return (*/}
                {/*        <PaddingBox key={index}>*/}
                {/*            <ListTagValue isFirstMastered={masterSkill.value === item}*/}
                {/*                          last={masterSkill.index === index}>{getSkillName(item)}</ListTagValue>*/}
                {/*        </PaddingBox>*/}
                {/*    )*/}
                {/*})}*/}

            </SequenceWrapper>
        </Wrapper>
    );
};


const SkillContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const SkillContentSkillText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  text-align: center;
  color: ${props => props.theme.color.green_100};
`;

const SkillContentSequenceWrapper = styled.div`
  margin-left: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
const SkillContentSequence = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: ${props => {
    let color = props.theme.color.gray_200
    if (props.selected) {
      color = props.theme.color.green_100
    }
    return color
  }};
  color: ${props => props.theme.color.site_main_color};
`;

const SkillContentBox = ({list, skillId, skillList}) => {
    const version = useSelector((state) => state.gameVersion.version);
    const getSkillId = (skillName) => {
        switch (skillName) {
            case 'Q':
                return 0;
            case 'W':
                return 1;
            case 'E':
                return 2;
            case 'R':
                return 3;
            default:
                return 0
        }
    }


    return (
        <SkillContentWrapper>
            <SkillContentSkillText>
                {skillId}
            </SkillContentSkillText>
            <div>
                <ChampionSkillImage
                    width={24}
                    height={24}
                    spell={skillList?.spells[getSkillId(skillId)]}
                    version={version}
                    img={skillList?.spells[getSkillId(skillId)]?.image?.full}
                />
            </div>
            <SkillContentSequenceWrapper>
                {Array.from({length: 14}).map((_, index) => {
                    const skillValue = getSkillId(skillId) + 1;
                    const contentValue = list?.[index]
                    if (skillValue === contentValue) {
                        return (
                            <SkillContentSequence selected={true} key={index}>
                                {index + 1}
                            </SkillContentSequence>
                        )
                    }
                    return (
                        <SkillContentSequence key={index}/>
                    )
                })}
            </SkillContentSequenceWrapper>
        </SkillContentWrapper>

    )
}

export default BuildSkillSq;